import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Thumbs, FreeMode, Autoplay } from 'swiper';
import { useDispatch, useSelector } from 'react-redux';
import { CommonApiFun } from '../../Redux/Action/index'
import { useNavigate } from 'react-router-dom'
import { routes } from '../../MainPage';
// import svg from '../../img/symbol.svg'
function Specialists(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    var reviewArr = useSelector((state) => state.reviewHome)
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    SwiperCore.use([Autoplay])
    const [swiperThumbs, updateSwiperThumbs] = useState(null);

    var reviewArr1 = reviewArr.filter((item) => item.display_status == "0")
    var reviewArr2 = reviewArr.filter((item) => item.display_status == "1")

    useEffect(() => {
        var data = { action: "patient_review" }
        dispatch(CommonApiFun("api/Api_controller/post", JSON.stringify(data))).then((res) => {
            dispatch({ type: 'REVIEW_HOME', payload: res.data })
        }).catch((e) => {

        })
    }, [])

    const slides = [];
    const patientImageSlides = [];
    reviewArr.forEach((item, idx) => {
        if (idx < 6) {
            patientImageSlides.push(
                <SwiperSlide className="patient_slide" key={idx}>
                    <a href="javascript:void(0)">
                        <img src={item.profile_image != "" ? item.profile_image : require('../../img/evnetPlaceHolder.png')} />
                        {item.profile_image == "" && <span>{item.name.charAt(0)}</span>}
                    </a>
                </SwiperSlide>
            )
            slides.push(
                <SwiperSlide className="swiper-slide patient_says_item" key={idx}>
                    <span>
                        <i className="fas fa-quote-left" />
                    </span>
                    <h5>{item.name}</h5>
                    <p>{item.review_description}</p>

                    <div className="review_star">
                        <i className="fas fa-star" style={{ color: item.rate >= 1 ? '' : 'gray' }} />
                        <i className="fas fa-star" style={{ color: item.rate >= 2 ? '' : 'gray' }} />
                        <i className="fas fa-star" style={{ color: item.rate >= 3 ? '' : 'gray' }} />
                        <i className="fas fa-star" style={{ color: item.rate >= 4 ? '' : 'gray' }} />
                        <i className="fas fa-star" style={{ color: item.rate >= 5 ? '' : 'gray' }} />
                    </div>
                </SwiperSlide>
            );
        }
    });

    return (
        <div className="web-sect">
            <div className="patient_says">
                <div className="container">
                    <div className="title-box title_btn"><span className="title_span"><span className="subtitle">Customer Testimonials</span><h3 className="text-center">Our Satisfaction</h3></span><button className="btn text-center" onClick={() => { navigate(routes.AllReview) }}>View All</button></div>
                    {/* <div className="title-box">
                        <span className="subtitle">Patient’s says</span>
                        <h3 className="text-center">Top Rated Specialists</h3>
                        <h3 className="text-center" onClick={() => { navigate(routes.AllReview) }}>View All</h3>
                    </div> */}
                    <div className="row align-center">
                        <div className="col-xs-12 col-md-12 col-6">
                            <div className="patient_says_img">
                                <div className="patient_wraper">
                                    <img
                                        className="bg-img"
                                        src={require('../../img/patient-bg.png')}
                                        alt="doctors bg"
                                    />
                                    <Swiper
                                        modules={[Navigation, Pagination, Thumbs, FreeMode]}
                                        onSwiper={updateSwiperThumbs}
                                        initialSlide={0}
                                        className="gallery_thumb"
                                        spaceBetween={0}
                                        slidesPerView={1}
                                        effect={"fade"}
                                        autoHeight={true}
                                        freeMode={true}
                                    // autoplay={{ delay: 500 }}
                                    >
                                        {patientImageSlides}
                                    </Swiper>

                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-12 col-6">
                            <div className="patient_says_txt">
                                <Swiper
                                    loop={true}
                                    initialSlide={0}
                                    modules={[Navigation, Pagination, FreeMode, Thumbs]}
                                    allowTouchMove={true}
                                    className="patient_says_box"
                                    spaceBetween={0}
                                    slidesPerView={1}
                                    effect={"slide"}
                                    autoHeight={true}

                                    pagination={{
                                        el: ".swiper-pagination",
                                        clickable: true,
                                    }}
                                    navigation={{
                                        nextEl: '.swiper-button-next',
                                        prevEl: '.swiper-button-prev',
                                    }}
                                    // autoplay={{ delay: 8000, }}
                                    // getSwiper= {updateSwiper} // Get swiper instance callback
                                    // thumbs={{
                                    //     swiper: sliderThumbs
                                    // }}
                                    thumbs={{ swiper: swiperThumbs }}

                                >

                                    {slides}
                                </Swiper>
                                <div className="swiper-buttons-group">
                                    <div className="swiper-button-prev">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                                            <path
                                                xmlns="http://www.w3.org/2000/svg"
                                                d="m54 30h-39.899l15.278-14.552c.8-.762.831-2.028.069-2.828-.761-.799-2.027-.831-2.828-.069l-17.448 16.62c-.755.756-1.172 1.76-1.172 2.829 0 1.068.417 2.073 1.207 2.862l17.414 16.586c.387.369.883.552 1.379.552.528 0 1.056-.208 1.449-.621.762-.8.731-2.065-.069-2.827l-15.342-14.552h39.962c1.104 0 2-.896 2-2s-.896-2-2-2z"
                                            />
                                        </svg>
                                    </div>
                                    <div className="swiper-button-next">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                                            <path
                                                xmlns="http://www.w3.org/2000/svg"
                                                d="m37.379 12.552c-.799-.761-2.066-.731-2.827.069-.762.8-.73 2.066.069 2.828l15.342 14.551h-39.963c-1.104 0-2 .896-2 2s.896 2 2 2h39.899l-15.278 14.552c-.8.762-.831 2.028-.069 2.828.393.412.92.62 1.448.62.496 0 .992-.183 1.379-.552l17.449-16.62c.756-.755 1.172-1.759 1.172-2.828s-.416-2.073-1.207-2.862z"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default Specialists;